import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../../redux/store';
import { createCatalogueApi, getCatalogueByIdApi, updateCatalogueApi } from '../../../../../redux/slices/CatalogueSlice';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

const CatalogueForm = () => {
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Formik configuration
  const formik = useFormik({
    initialValues: {
      name: '',
      catalogue_drive_link:'',
      // catalogue_file: null as File | null, // Ensure the type is File or null
      is_active: 0,
    },
    validationSchema: Yup.object({
          name: Yup.string().required('Name is required'),
          catalogue_drive_link: Yup.string().required('Catalogue drive link is required'),
        }),
    onSubmit: async (values) => {
      setLoading(true);
      const formData = new FormData();
      formData.append('name', values.name);
      formData.append('catalogue_drive_link', values.catalogue_drive_link);
      formData.append('is_active', values.is_active.toString());
      // if (values.catalogue_file) {
      //   formData.append('catalogue_file', values.catalogue_file);
      // }

      let data;
      if (id) {
        // Update catalogue API call
        data = await dispatch(updateCatalogueApi({ id, payload: formData }));
      } else {
        // Create new catalogue API call
        data = await dispatch(createCatalogueApi(formData));
      }

      if (data.payload.success) {
        setLoading(false);
        toast.success(data.payload.reason);
      } else {
        setLoading(false);
        toast.error(data.payload.reason ? data.payload.reason : 'Something went wrong');
      }
      navigate(-1);
    },
  });

  useEffect(() => {
    if (id) {
      fetchCatalogueData();
    }
  }, [id]);

  // const fetchCatalogueData = async () => {
  //   const response = await dispatch(getCatalogueByIdApi(id))
  //   if (response.payload.success) {
  //     formik.setValues(response.payload.data?.data)
  //   } else {
  //     toast.error('Failed to fetch catalogue data')
  //   }
  // }
  const fetchCatalogueData = async () => {
    try {
      const response = await dispatch(getCatalogueByIdApi(id));
      if (response.payload) {
        const fetchedData = response.payload.data?.data || response.payload;
        console.log(fetchedData);
        formik.setValues({
          ...fetchedData,
        });
      }
    } catch (error) {
      toast.error('An error occurred while fetching data');
    }
  };
  


  return (
    <div className="container mt-4">
      <div className="card shadow" style={{ height: 'auto', minHeight: '500px' }}>
        <form onSubmit={formik.handleSubmit}>
          {/* Card Header */}
          <div className="card-header bg-light d-flex justify-content-between align-items-center position-relative py-6">
            <h2 className="mb-0">{id ? 'Edit catalogue' : 'Add catalogue'}</h2>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Saving...' : id ? 'Update' : 'Submit'}
            </button>
            <span
              className={`position-absolute border-primary`}
              style={{
                top: '12px',
                left: '0',
                height: '70%',
                width: '4px',
                backgroundColor: 'var(--bs-primary)',
              }}
            ></span>
          </div>

          {/* Card Body */}
          <div className="card-body p-6">
            <div className="row g-3">
              {/* Name */}
              <div className="col-md-6">
                <label htmlFor="name" className="form-label">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-control"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Enter catalogue name"
                />
                {formik.touched.name && formik.errors.name && (
                  <div className="text-danger">{formik.errors.name}</div>
                )}
              </div>

              {/* Status */}
              <div className="col-md-6">
                <label htmlFor="status" className="form-label me-3">
                  Status
                </label>
                <select
                  id="status"
                  name="status"
                  className="form-select"
                  value={formik.values.is_active}
                  onChange={(e) => {
                    const value = e.target.value === '1' ? 1 : 0; // Correct mapping
                    formik.setFieldValue('is_active', value);
                  }}
                >
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>

              <div className="col-md-6">
                <label htmlFor="catalogue_drive_link" className="form-label">
                Catalogue Drive Link <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="catalogue_drive_link"
                  name="catalogue_drive_link"
                  className="form-control"
                  value={formik.values.catalogue_drive_link}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Enter catalogue drive link"
                />
                {formik.touched.catalogue_drive_link && formik.errors.catalogue_drive_link && (
                  <div className="text-danger">{formik.errors.catalogue_drive_link}</div>
                )}
              </div>


              {/* catalogue File */}
              {/* <div className="col-md-6">
                <label htmlFor="catalogueFile" className="form-label">
                  Catalogue File <span className="text-danger">*</span>
                </label>
                <input
                  type="file"
                  id="catalogueFile"
                  name="catalogueFile"
                  className="form-control"
                  onChange={(e) => {
                    if (e.target?.files?.[0]) {
                      formik.setFieldValue('catalogue_file', e.target.files[0]);
                    }
                  }}
                />
              </div> */}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CatalogueForm;
